import { gql } from "@apollo/client";

export const INSPECTIONS_LIST = gql`
  query InspectionsList($sort: [InspectionSort!], $first: Int, $skip: Int) {
    inspectionsList(sort: $sort, first: $first, skip: $skip) {
      items {
        id
        title
        category
        date
        inspector
        notes
        checklist
        checklistNotes
        inspections {
          id
          make
          model
        }
        workOrders {
          items {
            id
            title
            category
            status
            dateOpened
            estimatedCompletionDate
            workOrderDetails
            repairNotes
            createdAt
            updatedAt
          }
        }
        updatedAt
        createdAt
      }
      count
    }
  }
`;

export const INSPECTION_GET = gql`
  query InspectionGet($id: ID!) {
    inspection(id: $id) {
      id
      title
      category
      date
      inspector
      notes
      checklist
      checklistNotes
      inspections {
        id
          make
          model
      }
      workOrders {
        items {
          id
          title
          category
          status
          dateOpened
          estimatedCompletionDate
          workOrderDetails
          repairNotes
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const INSPECTION_CREATE = gql`
  mutation InspectionCreate($data: InspectionCreateInput!) {
    inspectionCreate(data: $data) {
      id
      title
      category
      date
      inspector
      notes
      checklist
      checklistNotes
    }
  }
`;

export const INSPECTION_UPDATE = gql`
  mutation InspectionUpdate(
    $filter: InspectionKeyFilter!
    $data: InspectionUpdateInput!
  ) {
    inspectionUpdate(filter: $filter, data: $data) {
      id
      title
      category
      date
      inspector
      notes
      checklist
      checklistNotes
      inspections {
        id
        make
        model
      }
    }
  }
`;

export const INSPECTION_DELETE = gql`
  mutation InspectionDestroy($filter: InspectionKeyFilter!) {
    inspectionDestroy(filter: $filter) {
      success
    }
  }
`;
